import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"6\" d=\"M80 100 30 70l-6 16M80 110H26l-4 14M82 120l-50 30 6 16M84 130l-24 48h16M120 100l50-30 6 16M120 110h54l4 14M118 120l50 30-6 16M116 130l24 48h-16\"></path><ellipse cx=\"100\" cy=\"118\" rx=\"40\" ry=\"34\"></ellipse><circle cx=\"100\" cy=\"84\" r=\"20\"></circle><circle cx=\"90\" cy=\"82\" r=\"5\" fill=\"var(--mc-avatar)\"></circle><circle cx=\"110\" cy=\"82\" r=\"5\" fill=\"var(--mc-avatar)\"></circle>", 5)
  ]))]))
}
export default { render: render }